


























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SwitchInput from '../../../../../../Pi/fields/SwitchInput/SwitchInput.vue'
import { FieldData } from '../../../../../../Pi/types'
import { TagData } from '../../../../../../Tags/types'
import SettingsMessageManager from '../../../logic/SettingsMessageManager'

@Component({
  components: {
    SwitchInput,
  }
})
export default class MessageSettingsDisableLinkPreview extends Vue {
  @Prop() settingsMessageManager!: SettingsMessageManager

  @Prop() tariffTags?: Array<TagData>

  @Prop() disabled!: boolean

  inputConfig(arg: FieldData): FieldData {
    arg.setter = (val) => this.settingsMessageManager.setFieldValue('disable_link_preview', val)
    return arg
  }
}
